import {PlayerDurum} from "@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes";
import {otomatikGorevIslemeKapatmaOnayi} from "@/utils/otomatikGorevIslemeUyarisi";

/**
 * Native "Ayarlar" menüsündeki "Otomatik görev işleme (gece senkronu)"
 * anahtarının renderer ayağı.
 *
 * Ayarın SAHİBİ burasıdır (localStorage, `GorevYoneticisi.updateAutoPlay`);
 * Electron main süreci yalnız menü işaretini gösterir. Menüden tıklama önce
 * buraya gelir: kapatma isteği onaylı uyarıdan geçer (kalıcı kapatma gece
 * senkron planını öldürür), vazgeçilirse gerçek durum main'e geri bildirilir
 * ve menü işareti eski hâline döner. Bildirim sesi ayarıyla aynı desen —
 * `App.vue` mounted kancasından kurulur.
 *
 * Bu mantık daha önce İşlemler ekranındaki `AyarlarKarti.vue`'daydı; ürün
 * kararıyla arayüzden kaldırılıp native menüye taşındı (kullanıcı isteği:
 * "üstteki pencere menüsündeki Ayarlar'a koyulsun").
 */

/** Menü köprüsünün konuştuğu dış dünya — testte kolayca sahtelenir. */
export interface OtomatikIslemeKoprusuBaglami {
    /** Kalıcı tercihi yazar (`updateAutoPlay` commit'i). */
    tercihiYaz: (acik: boolean) => void;
    /** Player durumunu okur. */
    playerDurumu: () => PlayerDurum;
    /** Player olayı yayınlar (socket `player`). */
    playerEmit: (durum: PlayerDurum) => void;
    /** Gerçek durumu main'e bildirir (menü işareti düzeltilir). */
    durumuBildir: (acik: boolean) => void;
    /** Onaylı uyarı; varsayılanı gerçek diyalog, testte sahtelenir. */
    onayIste?: (kalici: boolean) => Promise<boolean>;
}

/**
 * Menüden gelen tek bir isteği işler.
 *
 * @param istenen Menü anahtarının YENİ (tıklama sonrası) konumu.
 * @returns Uygulanan gerçek tercih.
 */
export async function otomatikIslemeIsteginiIsle(
    istenen: boolean,
    baglam: OtomatikIslemeKoprusuBaglami
): Promise<boolean> {
    const onayIste = baglam.onayIste ?? otomatikGorevIslemeKapatmaOnayi;

    if (istenen) {
        baglam.tercihiYaz(true);
        // Ayardan açan kullanıcı botu şimdi de çalışır görmek ister.
        baglam.playerEmit(PlayerDurum.oto);
        baglam.durumuBildir(true);
        return true;
    }

    // Kapatma yıkıcı: gece senkron planı çalışmaz. Onay alınmadan uygulanmaz.
    const onay = await onayIste(true);

    if (!onay) {
        // Menü işareti tıklamayla çevrilmişti; gerçek durumla geri düzeltilir.
        baglam.durumuBildir(true);
        return true;
    }

    baglam.tercihiYaz(false);
    // Tercih kalıcı olarak kapandı; koşan bot da durdurulur.
    if (baglam.playerDurumu() === PlayerDurum.oto) {
        baglam.playerEmit(PlayerDurum.durduruluyor);
    }
    baglam.durumuBildir(false);
    return false;
}
